
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import InputForm from "@/components/base/form/InputForm.vue";
import { Getter, Action } from "vuex-class";
import { FormValid } from "@/config";

@Component({
	name: "Applicant",
	components: {
		InputForm
	}
})
export default class Applicant extends Vue {
	@Action("account/getApplicantList") private getApplicantList: any;
	@Action("account/addApplicant") private addApplicant: any;
	@Action("account/updateApplicant") private updateApply: any;
	@Action("account/deleteAppicant") private deleteApply: any;
	@Getter("id") private id!: any;
	$https: any;
	$confirm: any;
	$store: any;
	input = "";
	baseInfo: any = this.$store.state.account.baseInfo;
	unitId: any = this.$store.state.account.unitId;
	currentPage1 = 1;
	currentPage = 1;
	totalPage = 1;
	totalData = 0;
	multipleSelection = "";
	loading = false;
	dialogVisible = false;
	dialogVisible2 = false;
	formRules: any = {
		act: [
			{
				required: true,
				message: "请输入账号",
				trigger: "change"
			},
			{
				required: true,
				message: "请输入账号",
				trigger: "blur"
			}
		],
		name: [
			{
				required: true,
				message: "请输入姓名",
				trigger: "change"
			},
			{
				required: true,
				message: "请输入姓名",
				trigger: "blur"
			},
			{ validator: FormValid.name }
		],
		password: [
			{
				required: true,
				message: "请输入密码",
				trigger: "change"
			},
			{
				required: true,
				message: "请输入密码",
				trigger: "blur"
			},
			{ validator: FormValid.password }
		],
		phone: [
			{
				required: true,
				message: "请输入手机号",
				trigger: "change"
			},
			{
				required: true,
				message: "请输入手机号",
				trigger: "blur"
			},
			{ validator: FormValid.phone }
		]
	};
	setting: any = [
		{
			label: "账号",
			ref: "act",
			type: "input",
			required: true,
			span: 24
		},
		{
			label: "姓名",
			ref: "name",
			type: "input",
			required: true,
			disabled: false,
			span: 24
		},
		{
			label: "手机号",
			type: "input",
			ref: "phone",
			required: true,
			disabled: false,
			span: 24
		},
		{
			label: "密码",
			ref: "password",
			type: "password",
			required: true,
			disabled: false,
			span: 24
		}
	];
	formData = {
		act: "",
		name: "",
		phone: "",
		password: ""
	};
	formData2: any = {
		act: "",
		name: "",
		phone: "",
		password: ""
	};
	setting2: any = [
		{
			label: "账号",
			ref: "act",
			type: "input",
			span: 24,
			required: true
		},
		{
			label: "姓名",
			ref: "name",
			type: "input",
			span: 24,
			required: true,
			disabled: false
		},
		{
			label: "手机号",
			type: "input",
			ref: "phone",
			span: 24,
			required: true,
			disabled: false
		}
	];
	resetPassword(item: any) {
		this.$prompt("请输入新密码", "提示", {
			confirmButtonText: "确定",
			cancelButtonText: "取消",
			inputPattern: /^[A-Za-z0-9]{5,9}$/,
			inputErrorMessage: "密码格式不正确",
			inputType: "password"
		})
			.then(({ value }: any) => {
				this.formData2.act = item.accountNumber;
				this.formData2.name = item.userName;
				this.formData2.phone = item.phone;
				this.formData2.password = "";
				this.formData2.id = item.id;
				if (value) {
					this.formData2.password = value;
				} else {
					this.formData2.password = "123456";
				}
				this.editApplicant();
			})
			.catch(() => {
				this.$message({
					type: "info",
					message: "取消修改密码"
				});
			});
	}
	handleSelectionChange(val: any) {
		this.multipleSelection = val;
	}
	publicityData = [];
	currentChange(param: number) {
		this.currentPage = param;
		this.getData();
	}
	handleClose(done: any) {
		(this.$refs.addApplicant as any).resetField();
		this.dialogVisible = false;
	}
	handleClose2(done: any) {
		(this.$refs.editApplicant as any).resetField();
		this.dialogVisible2 = false;
	}
	showEdit(item: any) {
		this.formData2.act = item.accountNumber;
		this.formData2.name = item.userName;
		this.formData2.phone = item.phone;
		this.formData2.password = "";
		this.formData2.id = item.id;
		this.dialogVisible2 = true;
	}
	getData() {
		this.loading = true;
		const options = {
			current: this.currentPage,
			size: 5
		};
		setTimeout(() => {
			this.loading = false;
		}, 30000);
		this.getApplicantList(options).then(({ code, data, msg }: any) => {
			if (code === 0) {
				this.totalData = data.total;
				this.totalPage = data.pages;
				this.publicityData = data.records;
				this.loading = false;
				return data;
			}
		});
	}
	deleteData(row: any) {
		const options = {
			declareId: row.id
		};

		this.deleteApply(options).then(({ code }: any) => {
			if (code === 0) {
				this.getData();
			}
		});
	}
	validateEdit() {
		(this.$refs.editApplicant as any).validForm();
	}
	editApplicant() {
		const options = {
			id: this.formData2.id,
			accountNumber: this.formData2.act,
			userName: this.formData2.name,
			password: this.formData2.password ? btoa(this.formData2.password) : null,
			phone: this.formData2.phone
		};
		this.updateApply(options).then(({ code }: any) => {
			if (code === 0) {
				this.$message.success("更新数据成功");
				this.getData();
				this.dialogVisible2 = false;
			}
		});
	}
	async addApplicantData() {
		const state = await (this.$refs.addApplicant as any).validFormReturn();
		if (!state) {
			return;
		}
		const options = {
			accountNumber: this.formData.act,
			userName: this.formData.name,
			phone: this.formData.phone,
			password: btoa(this.formData.password)
		};
		this.addApplicant(options).then((data: any) => {
			this.getData();
			this.dialogVisible = false;
			this.formData.act = "";
			this.formData.name = "";
			this.formData.phone = "";
			this.formData.password = "";
			this.loading = false;
		});
	}
	addData(item: any) {
		this.dialogVisible = true;
	}
	getUnitName() {
		const url = ``;
		const options = {};

		this.$https.get(url, options).then((res: any) => {});
	}
	created() {
		this.getData();
	}
}
